// extracted by mini-css-extract-plugin
export default {"formContainer":"IdentifierForm_formContainer__SPqP+","authButtons":"IdentifierForm_authButtons__q8fDo"};